import Model from "../../../core/Model";

export default class Login extends Model {
    constructor(obj = {}) {
        super();

        this.values = {
            email: null,
            password: null,
        }

        this.rules = {
            email: ['required', 'email'],
            password: ['required']
        };
    }
}
